<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }} - {{ form.name }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-collapse class="formset__list">
                            <div v-for="item, i in form.items" class="formset__item">
                                <el-collapse-item :name="i">
                                    <template slot="title">
                                        <formset-header :label="`${item.label_pl || 'Nowa pozycja'}`"
                                                        :items.sync="form.items"
                                                        :errors="checkForErrors(errors.items, [i])"
                                                        :index="i"/>
                                    </template>
                                    <menu-item :item.sync="item"
                                               :allow_submenu="form.allow_submenu"
                                               :errors="(errors.items && errors.items[i]) || {}"/>
                                </el-collapse-item>
                            </div>
                        </el-collapse>
                        <el-button @click="addMenuItem"
                                   class="fluid"
                                   type="primary">
                            Dodaj pozycje menu
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import MenuItem from '@/views/Menus/MenuItem'
    import {Menu} from '@/api/';

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'Menus List'},
                form: {},
                errors: {},
                service: Menu
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            MenuItem
        },
        methods: {
            fetchData () {
                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                    })
                }
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const service = id ? this.service.update(id, this.form) : this.service.save(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            },
            addMenuItem () {
                const blankObject = {
                    link: {}
                }
                if (!Array.isArray(this.form.items)) {
                    this.form['items'] = [blankObject]
                } else {
                    this.form.items.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// MenuForm.vue?a82f9dd8